import './tabs.css'
export const Tabs = (props) => {
    return (
        <section style={{gridTemplateColumns: `repeat(${props.options.length}, 1fr)`, ...props.style}} className='tabs-component'>
            {
                props.options.map((val, i) => (
                    <div key={i} onClick={()=> props.onClick(val)} className={`${val === props.selected ? 'tabs-component-option_selected' : ''} tabs-component-option`}>
                        <h2>{val}</h2>
                    </div>
                ))
            }
        </section>
    )
}